import { ReactNode } from "react";
import styles from './EditorHint.module.scss';
import { Alert, Box, Button, Typography } from "@mui/material";
import Link from "next/link";
import { Edit, Engineering } from "@mui/icons-material";

interface EditorHintProps {
    children: ReactNode;
    description?: string;
    route?: {
        url: string;
        label?: string;
    }
}

export default function EditorHint({ children, description, route }: EditorHintProps) {
    return (
        <Box className={styles.editorHintWrapper}>
            <Alert
                severity="info"
                icon={<Engineering />}
                className="mb-2"
                action={route && (
                    <Button
                        component={Link}
                        href={route.url}
                        color="inherit"
                        startIcon={<Edit />}
                        size="small"
                    >
                        {route.label || 'Bearbeiten'}
                    </Button>
                )}
            >
                <Typography variant="body2" fontSize="small">{description || "Diese Daten werden im Admin Bereich gepflegt"}</Typography>
            </Alert>
            {children}
        </Box>
    )
}
